<div class="d-flex gap-3">
  <div class="container-box shadow-none flex-fill text-center py-5">
    <div class="w-75 m-auto">
      <img src="/assets/images/channel-wizards/complete-icon.webp" alt="" height="50" />
      <h6 class="mt-2" i18n>Congratulations!</h6>
      <p i18n>
        Great! Now you're ready to connect each listing to the corresponding AdvanceCM rental(s). You will now be taken
        to the Agoda channel details screen where clicking into any of your rooms will initiate the wizard steps for
        each room.
      </p>
      <div class="alert alert-secondary-warning2 align-items-start text-left">
        <i class="cs-icon cs-icon-alert-triangle2 alert-icon"></i>
        <div class="alert-content">
          <b i18n>Note:</b>
          <ng-container i18n
            >If you are unable to see your listings under mapped rentals, please give Agoda.com time to fulfil your
            request and refresh the room list using the Actions button.</ng-container
          >
        </div>
      </div>
      <div class="d-flex gap-3 align-items-center justify-content-center mt-4">
        <button class="btn btn-secondary-info" (click)="reset.emit()">
          <i class="far fa-link"></i> <ng-container i18n>Connect another account</ng-container>
        </button>
        <button class="btn btn-secondary-primary" (click)="channel.emit()">
          <i class="cs-icon cs-icon-list-square"></i> <ng-container i18n>Channel Details</ng-container>
        </button>
      </div>
    </div>
  </div>
  <div class="channel-wizard-right-wrapper rounded px-4 py-5">
    <img src="/assets/images/channel-wizards/agoda/complete.webp" alt="" class="w-100" />
  </div>
</div>
<div class="mt-3 d-flex align-items-center justify-content-end">
  <button class="btn btn-secondary-info" (click)="done.emit()">
    <i class="cs-icon cs-icon-tasks"></i>
    <ng-container i18n>Done</ng-container>
  </button>
</div>
